import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { catchError, map } from 'rxjs/operators';
import { Sentiment } from '../model/sentiment';
import { APP_SETTINGS } from '../../shared/models/backofficeConfiguration';
import { ExecuteService } from '../../shared/services/executeService.service';
import { ErrorHandlerService } from '../../shared/services/errorHandler.service';

@Injectable()
export class SentimentService {
  private apiURL = APP_SETTINGS.MarketToolBOApiUrl;

  constructor(
    private executeService: ExecuteService,
    private errorHandler: ErrorHandlerService) {
  }

  public Post(locale: string, sentiment: Sentiment){
    const url = `${this.apiURL}api/${locale}/sentimentmanager`;
    var data = sentiment;
    return this.executeService.ExecuteWithToken('post', url, null, data)
    .pipe(
        catchError(this.errorHandler.handleError<object>('SentimentService_Post', null))
    );
  }

  public Put(locale: string, id: string, sentiment: Sentiment){
    const url = `${this.apiURL}api/${locale}/sentimentmanager/${id}`;
    var data = sentiment;
    return this.executeService.ExecuteWithToken('put', url, null, data)
    .pipe(
        catchError(this.errorHandler.handleError<object>('SentimentService_Put', null))
    );
  }

  public Get(locale: string, isActive: boolean, sentimentGroupId: string, isBullishFilter: boolean): Observable<Sentiment[]> {
    var url = `${this.apiURL}api/${locale}/sentimentmanager/${isActive}`;
    if(Boolean(sentimentGroupId)){
      url += `/${sentimentGroupId}`;
    }
    if (typeof(isBullishFilter) === 'boolean') {
      url += `/${isBullishFilter}`;
    }
    return this.executeService.ExecuteWithToken('get', url)
    .pipe(
        catchError(this.errorHandler.handleError('SentimentService_Get', [], true))
    );
  }

  public GetById(locale: string, id: string): Observable<Sentiment> {
    const url = `${this.apiURL}api/${locale}/sentimentmanager/${id}`;
    return this.executeService.ExecuteWithToken('get', url)
    .pipe(
      catchError(this.errorHandler.handleError('SentimentService_Get', [], true))
    );
  }

  public Delete(locale: string, id: string) {
    const url = `${this.apiURL}api/${locale}/sentimentmanager/${id}`;
    return this.executeService.ExecuteWithToken('delete', url)
      .pipe(
        catchError(this.errorHandler.handleError('SentimentService_Delete', [], true))
      );
  }
}



// WEBPACK FOOTER //
// ./src/app/sentiment/services/sentiment.service.ts